(() => {
  const tag = 'shopify-forms-embed';
  const styleId = 'sn-forms-mobile-stability';
  const openForms = new Set();
  const css = `@media (max-width: 768px) {
    [data-testid="app-router"]:has(#form-container-ref) {
      animation: none !important;
      transform: none !important;
    }
    [data-form-root][data-layout="floating"]:has([data-testid="form-teaser"]) {
      left: 0 !important;
      right: auto !important;
      top: 50% !important;
      bottom: auto !important;
      width: max-content !important;
      padding: 0 !important;
      rotate: none !important;
      transform: translateY(-50%) !important;
    }
    [data-form-root][data-layout="floating"]:has([data-testid="form-teaser"]) [data-testid="app-router"] {
      animation: none !important;
      transform: none !important;
    }
    [data-form-root][data-layout="floating"] [data-testid="form-teaser"] {
      writing-mode: vertical-rl;
      width: auto !important;
      min-width: 0 !important;
      padding: 12px 8px !important;
      margin: 0 !important;
      border-radius: 0 10px 10px 0 !important;
    }
  }`;

  const visibilityStyle = document.createElement('style');
  visibilityStyle.textContent = `
    html[data-sn-forms-open] #astra-widget-container {
      --sn-astra-visibility: hidden;
      visibility: hidden !important;
      pointer-events: none !important;
    }
    html[data-sn-forms-open] .sn-whatsapp,
    html[data-sn-forms-open] sn-video-widget {
      visibility: hidden !important;
      pointer-events: none !important;
    }
  `;
  document.head.appendChild(visibilityStyle);

  const install = (host) => {
    const root = host.shadowRoot;
    if (!root || root.getElementById(styleId)) return;
    const style = document.createElement('style');
    style.id = styleId;
    style.textContent = css;
    root.appendChild(style);
    let pending = false;
    const updateVisibility = () => {
      pending = false;
      const form = root.querySelector('[data-form-root][data-layout="floating"] #form-container-ref, [data-form-root][data-layout="overlay"] #form-container-ref');
      const shown = host.isConnected && form && form.getBoundingClientRect().height > 0 &&
        getComputedStyle(form).visibility !== 'hidden' && getComputedStyle(host).display !== 'none';
      if (shown) openForms.add(host); else openForms.delete(host);
      for (const entry of openForms) if (!entry.isConnected) openForms.delete(entry);
      document.documentElement.toggleAttribute('data-sn-forms-open', openForms.size > 0);
    };
    const schedule = () => {
      if (pending) return;
      pending = true;
      requestAnimationFrame(updateVisibility);
    };
    new MutationObserver(schedule).observe(root, { childList: true, subtree: true, attributes: true });
    new MutationObserver(schedule).observe(host, { attributes: true, attributeFilter: ['style', 'hidden'] });
    new ResizeObserver(schedule).observe(host);
    updateVisibility();
  };

  customElements.whenDefined(tag).then(() => {
    document.querySelectorAll(tag).forEach(install);
    const observer = new MutationObserver((records) => {
      for (const entry of openForms) if (!entry.isConnected) openForms.delete(entry);
      document.documentElement.toggleAttribute('data-sn-forms-open', openForms.size > 0);
      for (const record of records) {
        for (const node of record.addedNodes) {
          if (!(node instanceof Element)) continue;
          if (node.matches(tag)) install(node);
          node.querySelectorAll(tag).forEach(install);
        }
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
  });
})();
